export function brandSearch() {

    jQuery(function(){

        const brandSearch_box = document.querySelector('.p-brandSearch_box');
        if(brandSearch_box) {
            
            //■■■■■■■■■■■■■■■ toggleボタン 開閉 ■■■■■■■■■■■■■■■■
            $('.area_toggle').on('click', function(){
                if($(this).hasClass('is-open')){
                    $(this).removeClass('is-open');
                    $(this).next('ul').removeClass('is-active').slideUp();
                }else{
                    $(this).addClass('is-open');
                    $(this).next('ul').addClass('is-active').slideToggle().css({"display": "flex"});
                }
            });

            //■■■■■■■■■■■■■■■ check制御 ■■■■■■■■■■■■■■■■

            $(document).ready(function() {
                // 1. URLパラメータから初期化
                initFromUrlParams();
                
                // 2. 初期状態同期
                syncAllCheckboxes();
                syncParentCheckboxes();
                
                // 3. 全チェックボックス変更監視
                $(document).on('change', '.areaSelect_wrap input[type="checkbox"]', function(e) {
                    var $checkbox = $(this);
                    var isChecked = $checkbox.prop('checked');
                    
                    // 親チェックボックスの場合：子孫も連動
                    if ($checkbox.closest('.areaSelect').length || $checkbox.closest('.areaSelect_chiled').length) {
                        setChildrenState($checkbox, isChecked);
                    }
                    
                    // 親チェーン更新
                    updateParentChain($checkbox);
                    syncAllParents();
                    
                    // チェックON時に親ul展開
                    if (isChecked && $checkbox.closest('ul').length) {
                        expandParentUls($checkbox);
                    }
                    
                    updateEmptyDisplay();
                });
                
                // 4. 「すべて」チェックボックスの特別処理
                $('#area_all').on('change', function() {
                    var isChecked = $(this).prop('checked');
                    $('.areaSelect input[type="checkbox"]').prop('checked', isChecked);
                    syncAllCheckboxes();
                });
            });

            /**
             * サーバー側で既にchecked済み（store_area_term[]をPHPが復元済み）のチェックボックスを起点に
             * アコーディオンを展開する。store_area_termはタームIDのため値のパターンに依存しない。
             */
            function initFromUrlParams() {
                var expandedNodes = [];

                $('.areaSelect_wrap input[name="store_area_term[]"]:checked').each(function() {
                    collectExpandNodes($(this), expandedNodes);
                });

                // イベントトリガ + 展開実行
                expandedNodes.forEach(function(node) {
                    node.checkbox.trigger('change');
                    expandNode(node);
                });
            }

            /**
             * チェックボックスから親チェーンをたどり展開対象収集（正確版）
             */
            function collectExpandNodes($checkbox, expandedNodes) {
                var $cityUl = $checkbox.closest('ul');
                var $prefectureLi = $cityUl.closest('li');
                var $prefectureUl = $prefectureLi.closest('ul.areaSelect_chiled');
                var $regionLi = $prefectureUl.closest('li');
                
                // 第三階層ul + 同一li内のtoggle（直前兄弟）
                expandedNodes.push({
                    checkbox: $checkbox,
                    ul: $cityUl,
                    toggle: $cityUl.prevAll('.area_toggle:first')
                });
                
                // 第二階層ul + 同一li内のtoggle（直前兄弟）
                expandedNodes.push({
                    checkbox: $checkbox,
                    ul: $prefectureUl,
                    toggle: $prefectureUl.prevAll('.area_toggle:first')
                });
            }

            /**
             * ul展開処理（is-active + is-open付与・正確版）
             */
            function expandNode(node) {
                if (node.ul.length) {
                    node.ul.addClass('is-active').css('display', 'flex');
                    node.toggle.addClass('is-open');
                }
            }

            /**
             * チェックON時の親ul展開（正確版）
             */
            function expandParentUls($checkbox) {
                var $cityUl = $checkbox.closest('ul');
                var $prefectureLi = $cityUl.closest('li');
                var $prefectureUl = $prefectureLi.closest('ul.areaSelect_chiled');
                var $regionLi = $prefectureUl.closest('li');
                
                // 第三階層ul展開 + 直前兄弟toggleのみ
                $cityUl.addClass('is-active').css('display', 'flex');
                $cityUl.prevAll('.area_toggle:first').addClass('is-open');
                
                // 第二階層ul展開 + 直前兄弟toggleのみ
                $prefectureUl.addClass('is-active').css('display', 'flex');
                $prefectureUl.prevAll('.area_toggle:first').addClass('is-open');
            }

            /**
             * 親チェックボックスON/OFFで子孫連動
             */
            function setChildrenState($parentCheckbox, checkedState) {
                var $children;
                if ($parentCheckbox.closest('.areaSelect').length && !$parentCheckbox.closest('.areaSelect_chiled').length) {
                    $children = $parentCheckbox.closest('li').find('.areaSelect_chiled input[type="checkbox"]');
                }
                else if ($parentCheckbox.closest('.areaSelect_chiled').length) {
                    $children = $parentCheckbox.closest('li').find('ul input[type="checkbox"]');
                }
                if ($children && $children.length > 0) {
                    $children.prop('checked', checkedState);
                }
            }

            /**
             * 変更チェックボックスの親チェーン更新
             */
            function updateParentChain($checkbox) {
                if ($checkbox.closest('ul').closest('.areaSelect_chiled').length) {
                    updateParentCheckbox($checkbox);
                    updateRegionCheckbox($checkbox);
                    updateAllCheckbox();
                }
                else if ($checkbox.closest('.areaSelect_chiled').length && 
                        !$checkbox.closest('ul').closest('.areaSelect_chiled').length) {
                    updateRegionCheckbox($checkbox);
                    updateAllCheckbox();
                }
                else if ($checkbox.closest('.areaSelect').length && 
                        !$checkbox.closest('.areaSelect_chiled').length) {
                    updateAllCheckbox();
                }
            }

            /**
             * 全親階層再同期（兄弟要素変化対応）
             */
            function syncAllParents() {
                // 第三→第二（全都道府県）
                $('.areaSelect_chiled').each(function() {
                    var $prefectureLi = $(this).closest('li');
                    var $prefectureCheckbox = $prefectureLi.find('label.checkbox > input[type="checkbox"]:first');
                    var $cityCheckboxes = $prefectureLi.find('ul input[type="checkbox"]');
                    if ($prefectureCheckbox.length && $cityCheckboxes.length > 0) {
                        var allCitiesChecked = $cityCheckboxes.filter(':checked').length === $cityCheckboxes.length;
                        $prefectureCheckbox.prop('checked', allCitiesChecked);
                    }
                });
                
                // 第二→第一（全地域）
                $('.areaSelect > li').each(function() {
                    var $regionCheckbox = $(this).find('label.checkbox > input[type="checkbox"]:first');
                    var $prefectureCheckboxes = $(this).find('.areaSelect_chiled > li > label.checkbox > input[type="checkbox"]');
                    
                    if ($regionCheckbox.length && $prefectureCheckboxes.length > 0) {
                        var allPrefsChecked = $prefectureCheckboxes.filter(':checked').length === $prefectureCheckboxes.length;
                        $regionCheckbox.prop('checked', allPrefsChecked);
                    }
                });
                
                // 第一→全国
                updateAllCheckbox();
            }

            /**
             * 市区町村→都道府県
             */
            function updateParentCheckbox($cityCheckbox) {
                var $prefectureLi = $cityCheckbox.closest('ul').closest('li');
                var $prefectureCheckbox = $prefectureLi.find('label.checkbox > input[type="checkbox"]:first');
                if ($prefectureCheckbox.length) {
                    var $cityCheckboxes = $prefectureLi.find('ul input[type="checkbox"]');
                    var allCitiesChecked = $cityCheckboxes.length > 0 && 
                                        $cityCheckboxes.filter(':checked').length === $cityCheckboxes.length;
                    $prefectureCheckbox.prop('checked', allCitiesChecked);
                }
            }

            /**
             * 都道府県→地域
             */
            function updateRegionCheckbox($checkbox) {
                var $regionLi = $checkbox.closest('.areaSelect_chiled').closest('li');
                var $regionCheckbox = $regionLi.find('label.checkbox > input[type="checkbox"]:first');
                if ($regionCheckbox.length) {
                    var $prefectureCheckboxes = $regionLi.find('.areaSelect_chiled > li > label.checkbox > input[type="checkbox"]');
                    var allPrefsChecked = $prefectureCheckboxes.length > 0 && 
                                        $prefectureCheckboxes.filter(':checked').length === $prefectureCheckboxes.length;
                    $regionCheckbox.prop('checked', allPrefsChecked);
                }
            }

            /**
             * 地域→全国
             */
            function updateAllCheckbox() {
                var $regionCheckboxes = $('.areaSelect > li > label.checkbox > input[type="checkbox"]');
                var allRegionsChecked = $regionCheckboxes.length > 0 && 
                                    $regionCheckboxes.filter(':checked').length === $regionCheckboxes.length;
                $('#area_all').prop('checked', allRegionsChecked);
            }

            /**
             * 初期状態完全同期
             */
            function syncAllCheckboxes() {
                $('.areaSelect_chiled ul input[type="checkbox"]').each(function() {
                    updateParentCheckbox($(this));
                });
                $('.areaSelect_chiled input[type="checkbox"]').each(function() {
                    updateRegionCheckbox($(this));
                });
                $('.areaSelect > li > label.checkbox > input[type="checkbox"]').each(function() {
                    updateAllCheckbox();
                });
            }

            /**
             * 既存コード（第一階層→全国）
             */
            function syncParentCheckboxes() {
                var $prefectures = $('.areaSelect > li > label.checkbox > input[type="checkbox"]');
                var allPrefChecked = $prefectures.length > 0 && 
                                    !$prefectures.not(':checked').length;
                $('#area_all').prop('checked', allPrefChecked);
            }

            /**
             * 空リスト非表示
             */
            function updateEmptyDisplay() {
                $('.areaSelect_chiled').each(function() {
                    var $visibleLi = $(this).children('li:visible');
                    var $liWithEmptyUl = $visibleLi.has('> ul:empty');
                    if ($visibleLi.length > 0 && $visibleLi.length === $liWithEmptyUl.length) {
                        $(this).closest('li').hide();
                    }
                });
            }


            /*-----------------------
            ロード時
            ------------------------*/

            //■■■■■■■■■■■■■■■ 市町村の有無によって親のliの非表示処理 ■■■■■■■■■■■■■■■■

            $(function() {

                // 再帰的空要素クリーンアップ
                function hideEmptyContainers() {
                    let changed = false;
                    
                    // 第3階層のliをチェック、空は非表示
                    $('.areaSelect_chiled li:has(ul:empty)').hide();
                    changed = true;
                    
                    // 第2階層の非表示
                    $('.areaSelect_chiled').each(function() {
                        if ($(this).children('li:not([style*="display: none"]) ul:empty').length === 
                            $(this).children('li:not([style*="display: none"])').length) {
                            $(this).closest('li').hide();
                            changed = true;
                        }
                    });
                    
                    return changed;
                }
                
                // 変化がある間繰り返し
                let iterations = 0;
                while (hideEmptyContainers() && iterations++ < 5) {}
            });


            /*-----------------------
            パラメータ処理
            ------------------------*/
            // URLパラメータ取得用関数
            function getParam(name) {
            const params = new URLSearchParams(window.location.search);
            return params.get(name);
            }

            // URLパラメータを配列で取得する関数（複数指定対応）
            function getParamsArray(name) {
            const params = new URLSearchParams(window.location.search);
            return params.getAll(name);
            }

            // ========== store_area_term[] の処理 ==========
            // サーバー側（render_store_area_checkboxes）で既にchecked属性が復元されているため、
            // ここでの追加処理は不要（旧store_area/固定ID#area_07依存の処理は廃止）

            // ========== budget_min / budget_max の処理 ==========
            const budgetMin = getParam('budget_min');
            const budgetMax = getParam('budget_max');

            if (budgetMin) {
            const minSelect = document.querySelector('select#budget_min');
            if (minSelect) {
                const option = minSelect.querySelector(`option[value="${budgetMin}"]`);
                if (option) {
                option.selected = true;
                }
            }
            }

            if (budgetMax) {
            const maxSelect = document.querySelector('select#budget_max');
            if (maxSelect) {
                const option = maxSelect.querySelector(`option[value="${budgetMax}"]`);
                if (option) {
                option.selected = true;
                }
            }
            }

            // ========== store_service[] の処理 ==========
            const storeServices = getParamsArray('store_service[]');
            if (storeServices.length > 0) {
            storeServices.forEach(value => {
                const checkbox = document.querySelector(`input[type="checkbox"][name="store_service[]"][value="${value}"]`);
                if (checkbox) {
                checkbox.checked = true;
                }
            });
            }


            /*-----------------------
            絞り込みformのリセットボタン処理
            ------------------------*/

            $(document).on('click', '.btn_clear', function(e) {
                e.preventDefault();
                
                const $searchBox = $('.p-brandSearch_box');
                
                // 全input, selectをリセット
                $searchBox.find('input[type="text"], input[type="search"], input[type="email"], input[type="number"], textarea').val('');
                $searchBox.find('select').prop('selectedIndex', 0);
                $searchBox.find('input[type="radio"], input[type="checkbox"]').prop('checked', false);
                
                // URLパラメータ削除
                const newUrl = window.location.pathname;
                window.history.replaceState(null, null, newUrl);
            });



        }//brandSearch_box有無
    });


}
